import React, { FC } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

interface Props {
  open: boolean;
  handleConfirm: () => void;
  handleClose: () => void;
}

export const BackModal: FC<Props> = (props: Props) => {
  return (
    <Dialog
      open={props.open}
      onClose={props.handleClose}
      aria-labelledby="back-dialog-title"
      aria-describedby="back-dialog-description"
    >
      <DialogTitle id="back-dialog-title">Attenzione</DialogTitle>
      <DialogContent>
        <DialogContentText id="back-dialog-description">
          Per visualizzare la tua scelta e modificarla andrai ad azzerare tutte le scelte successive. Confermi di voler
          tornare indietro?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.handleClose} autoFocus variant="outlined">
          Annulla
        </Button>
        <Button onClick={props.handleConfirm} color="primary" variant="contained" disableElevation>
          Conferma
        </Button>
      </DialogActions>
    </Dialog>
  );
};
